import { createFileRoute, redirect } from '@tanstack/react-router';

/** The Forms module moved under Claims and products; old links keep working. */
export const Route = createFileRoute('/console/$orgId/configuration/api-integrations/form-designer/')({
    beforeLoad: ({ params }): never => {
        throw redirect({ to: '/console/$orgId/configuration/claims-products/forms', params, replace: true });
    },
});
